import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface NotificationListTemplateProps {
  readonly headerActions: ReactNode;
  readonly content: ReactNode;
}

/**
 * Layout da página de listagem de notificações.
 *
 * Renderiza o cabeçalho com título/subtítulo, ações e o slot de conteúdo.
 */
export function NotificationListTemplate({
  headerActions,
  content,
}: NotificationListTemplateProps) {
  const { t } = useTranslation('notification');

  return (
    <div className="flex flex-col gap-quark">
      <div className="flex flex-wrap items-start justify-between gap-xs">
        <div className="flex flex-col gap-nano">
          <h1 className="ts-heading-lg text-ctx-content-title">{t('title')}</h1>
          <p className="ts-paragraph-xs text-ctx-content-title">{t('subtitle')}</p>
        </div>
        {headerActions}
      </div>

      {content}
    </div>
  );
}
